import { getPickupSchedules } from "./schedules";

export const pickup = {
    schedules: getPickupSchedules,
};
